module.exports = __webpack_public_path__ + "img/yellow-arrow.188e02f7.svg";